import React from 'react';
import { useParams } from 'react-router-dom';
import PasswordResetEmail from './PasswordResetEmail';
import SetNewPassword from './SetNewPassword';
import { injectIntl } from 'react-intl';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';

const PasswordReset = ({ intl }) => {
  const t = intl.messages.containers.ResetPassword;
  const loginConfig = getTenantPreLoginConfig().login_component;
  const { token } = useParams();
  if (loginConfig === 'google') return null;
  return (
    <>
      {token ? (
        <SetNewPassword t={t.set_password} token={token} />
      ) : (
        <PasswordResetEmail t={t.sent_email} />
      )}
    </>
  );
};

export default injectIntl(PasswordReset);
